/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

//const formattedDate = params => formatGivenDate( params.data.newBuildWeek, 'DD-MMM-YY' );

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 200
    },
    {
        field: 'newBuildWeek',
        headerName: 'New Build Week',
        sortable: true,
        filter: true,
        width: 160
     //   valueGetter: formattedDate
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        filter: true,
        width: 300
    }
];
const colDefsUpload = [
    {
        field: 'dateEntered',
        headerName: 'Date Entered',
        sortable: true,
        filter: true,
        width: 160
    },
    {
        field: 'timeEntered',
        headerName: 'Time Entered',
        sortable: true,
        filter: true,
        width: 160
    },
    {
        field: 'userIDEntered',
        headerName: 'User Id Entered',
        sortable: true,
        filter: true,
        width: 160
    }
];
const defaultColDef = {
    cellClassRules: {
        oddRowBackground: function ( params ) {

            return params.rowIndex % 2 === 0;

        }
    }
};
const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        font: {
            fontName: 'Calibri Light',
            underline: 'Single',
            italic: true,
            color: '#ff0000'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];
class BatchSubstitutionTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;
        // setTimeout( () => {
        //     this.gridApi.sizeColumnsToFit();
        // }, 500 );

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        // const message = `${this.props.oaKey} Order Availablity as of ${new Date()}`;
        const unit = this.props.results.length ? this.props.results[0].unitName : '';
        const submit = ( this.props.results.length && this.props.results[0].submit );
        const title = `Batch Upload - ${unit} - ${submit ? 'Upload' : 'Audit'}`;
        const generalParams = {
            fileName: title,
            sheetName: `${submit ? 'Upload' : 'Audit'} Results`,
            exportMode: 'xlsx',
            columnKeys: colKeys
            // customHeader: [
            //     [],
            //     [
            //         {
            //             styleId: 'regularHeader',
            //             data: {
            //                 type: 'String',
            //                 value: message
            //             },
            //             mergeAcross: 10
            //         }
            //     ],
            //     []
            // ]
        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    render () {

        // const message = `${this.props.oaKey} Order Availablity as of ${new Date()}`;
        const submit = ( this.props.results.length && this.props.results[0].submit );
        const displayColDefs = submit ? [...colDefs, ...colDefsUpload] : [...colDefs];
        if ( this.props.results.length && this.props.results[0].reportType === 'Combo' ) displayColDefs.splice( 5, 1 );
        return (

            <section className="atp-search-result-panel batch-substitution-result-panel ">

                {/* <div className="results-message">
                    {message}
                </div> */}

                <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        columnDefs={displayColDefs}
                        defaultColDef={defaultColDef}
                        rowData={this.props.results}
                        excelStyles={excelStyles}
                        onGridReady={this.onGridReady}
                        // getRowClass={getRowClass}
                    />
                </div>

            </section>
        );

    }

}

BatchSubstitutionTable.propTypes = {
    results: PropTypes.array.isRequired,
    time: PropTypes.number,
    oaKey: PropTypes.string
};
export default BatchSubstitutionTable;
